/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import ContentFrame from '../../applicationFrame/ContentFrame';
import { ScrollAwareContext, ScrollAwareScroller, ScrollAwareAppNavStep } from '../../components/ScrollAware';
import { AppHeaderScrollableTextWithLanguage } from '../../components/appNav/AppHeaderScrollable';
import UserService from '../../../apiServices/UserService';
import InputWithLabel from '../../components/InputWithLabel';
import { ExternalLink } from '../../components/TextLink';
import Card, { CardSection } from '../../components/card/Card';
import { validateEmail } from '../../../utilities/Validators';
import { TrackEvent } from '../../../utilities/UserMetrics';
import { GrayPrivacyCard } from '../../components/card/PrivacyCard';
import { PolicyName } from '../../../models/PolicyModel';
import ContentWrapper from '../../components/ContentWrapper';

class SignupEmail extends React.Component {

  constructor(props) {
    super(props);

    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.submitForm = this.submitForm.bind(this);

    this.state = {
      email: props.email,
      isEmailValid: validateEmail(props.email),
      isEmailInUse: false,
      errorMessage: '',
      submitAttemptCount: 0,
    };
  }


  onChangeEmail(e) {
    const value = e.target.value;
    this.setState({
      email: value,
      isEmailValid: validateEmail(value),
      isEmailInUse: false,
    });
  }


  goToReadTerms() {
    TrackEvent.signup.viewedTermsAtSignup();
  }

  submitForm(e) {
    e.preventDefault();
    if (!this.state.isEmailValid) {
      this.setState({
        errorMessage: <FormattedMessage id="error.email-validator.invalid-email.message" />,
        submitAttemptCount: this.state.submitAttemptCount + 1,
      });
      return;
    }

    UserService.checkEmailExists(this.state.email, (apiError, exists) => {
      if (exists) {
        this.setState({
          isEmailInUse: true,
          errorMessage: <FormattedMessage id="error.api-users.error.api-users.400-email-in-use.message" />,
        });
      } else {
        this.props.updateEmail(this.state.email);
        TrackEvent.signup.enteredEmailAddress();

        this.setState({
          submitAttemptCount: this.state.submitAttemptCount + 1,
        });

        this.props.goToNext();
      }
    });
  }

  render() {
    const { goToLogin, goToIntro } = this.props;

    return (
      <div>
        <ScrollAwareContext>
          <ScrollAwareAppNavStep
            next={this.submitForm}
            submitDisabled={!this.state.isEmailValid}
            login={goToLogin}
            color="white"
          />

          <ContentFrame>
            <ScrollAwareScroller>
              <AppHeaderScrollableTextWithLanguage
                id="signup.title.text"
                allowLanguageToggle={!IS_ANDROID_BUILD}
              />
              <ContentWrapper>
                <GrayPrivacyCard
                  name={PolicyName.EMAIL}
                  subTitle="privacy.privacyBlock.email.teaser"
                  customWithdrawConsent={IS_ANDROID_BUILD ? null : (
                    <FormattedMessage id="backpackHealth.url.url">
                      {
                        (url) => (
                          <ExternalLink href={url} className="font-subhead font-color-gsMiddle" openInCurrentWindow={true}>
                            <FormattedMessage id="privacy.dontConsent.button.label" />
                          </ExternalLink>
                        )
                      }
                    </FormattedMessage>
                  )}
                  onWithdrawConsent={IS_ANDROID_BUILD ? goToIntro : null}
                  onClickPrivacyLink={this.goToReadTerms}
                />

                <Card>
                  <CardSection>
                    <form onSubmit={this.submitForm}>
                      <div>
                        <InputWithLabel
                          value={this.state.email}
                          onChange={this.onChangeEmail}
                          type="email"
                          label={<FormattedMessage id="signupEmail.email.field.label" />}
                          isInvalid={this.state.isEmailInUse || (!this.state.isEmailValid && this.state.submitAttemptCount > 0)}
                          invalidHint={this.state.errorMessage}
                          attemptsBeforeInvalidHint={0}
                          name="email"
                          isClearable
                          clearValue={() => { this.setState({ email: '', isEmailValid: false }); }}
                        />
                      </div>

                      <input type="submit" style={{ visibility: 'hidden' }} />
                    </form>
                  </CardSection>
                </Card>
              </ContentWrapper>
            </ScrollAwareScroller>
          </ContentFrame>
        </ScrollAwareContext>
      </div>
    );
  }
}
SignupEmail.propTypes = {
  email: PropTypes.string,
  updateEmail: PropTypes.func,
  goToLogin: PropTypes.func,
  goToNext: PropTypes.func,
  goToIntro: PropTypes.func,
};

export default SignupEmail;
